import { decodeEntities } from "@wordpress/html-entities";

const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
const ownerGateways = window.yandexPaySplitOwnPaymentMethods;
const paymentGateways = window.wc.wcSettings.allSettings.paymentMethodData;

// Load the Yandex Pay SDK script dynamically
function loadYandexPaySDK() {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://pay.yandex.ru/sdk/v1/pay.js";
  script.onload = function () {
    // Once the script is loaded, call the onYaPayLoad function

    const YaPay = window.YaPay;
    const yps_root = window.yandexPaySplitCheckoutVariables;

    // Данные платежа
    const paymentData = {
      // Для отладки нужно явно указать `SANDBOX` окружение,
      // для продакшена параметр можно убрать или указать `PRODUCTION`
      env: YaPay.PaymentEnv.Production,

      // Версия 4 указывает на тип оплаты сервисом Яндекс Пэй
      // Пользователь производит оплату на форме Яндекс Пэй,
      // и мерчанту возвращается только результат проведения оплаты
      version: 4,

      // Код валюты в которой будете принимать платежи
      currencyCode: YaPay.CurrencyCode[yps_root.currency],

      // Идентификатор продавца, который получают при регистрации в Яндекс Пэй
      merchantId: yps_root.merchantId,

      // Сумма к оплате
      // Сумма которая будет отображена на форме зависит от суммы переданной от бэкенда
      // Эта сумма влияет на отображение доступности Сплита
      totalAmount: parseFloat(yps_root.sum),

      // Доступные для использования методы оплаты
      // Доступные на форме способы оплаты также зависят от информации переданной от бэкенда
      // Данные передаваемые тут влияют на внешний вид кнопки или виджета
      availablePaymentMethods: ["CARD", "SPLIT"],
    };

    // Обработчик на клик по кнопке
    // Функция должна возвращать промис которые резолвит ссылку на оплату полученную от бэкенда Яндекс Пэй
    // Подробнее про создание заказа: https://pay.yandex.ru/ru/docs/custom/backend/yandex-pay-api/order/merchant_v1_orders-post
    async function onPayButtonClick() {
      // Создание заказа...
      // и возврат URL на оплату вида 'https://pay.ya.ru/l/XXXXXX'
    }

    // Обработчик на ошибки при открытии формы оплаты
    function onFormOpenError(reason) {
      // Выводим информацию о недоступности оплаты в данный момент
      // и предлагаем пользователю другой способ оплаты.
      console.error(`Payment error — ${reason}`);
    }

    // Создаем платежную сессию
    YaPay.createSession(paymentData, {
      onPayButtonClick: onPayButtonClick,
      onFormOpenError: onFormOpenError,
    })
      .then(function (paymentSession) {
        Object.keys(paymentGateways).forEach(function (gatewayKey) {
          if (ownerGateways.indexOf(gatewayKey) >= 0) {
            const settings = paymentGateways[gatewayKey];
            const label = decodeEntities(settings.title);
            const widget = "";

            const Content = () => {
              return decodeEntities(settings.description || "");
            };

            const Icon = () => {
              return settings.icon ? (
                <img
                  src={settings.icon}
                  style={{ float: "right", marginRight: "20px" }}
                  alt={settings.title}
                />
              ) : (
                ""
              );
            };

            const Label = () => {
              let classname = "yps-yandex-pay__checkout-" + gatewayKey;
              return (
                <span style={{ width: "100%" }}>
                  {label}{" "}
                  <span
                    className={classname}
                    style={{ marginLeft: "10px" }}
                  ></span>
                  <Icon />
                </span>
              );
            };
            registerPaymentMethod({
              name: gatewayKey,
              label: <Label />,
              content: <Content />,
              edit: <Content />,
              canMakePayment: () => {
                // Используем MutationObserver для отслеживания изменений в DOM
                const observer = new MutationObserver((mutations, observer) => {
                  const paymentMethodsElement = document.querySelector(
                    ".yps-yandex-pay__checkout-" + gatewayKey
                  );
                  if (paymentMethodsElement) {
                    let classname = "yps-yandex-pay__checkout-" + gatewayKey;
                    const element = document.querySelector("." + classname); // Get the split element

                    if (
                      gatewayKey == "yps_pay" &&
                      element &&
                      yps_root.checkout_yandex_pay === "yes"
                    ) {
                      // Remove all child elements from the element
                      while (element.firstChild) {
                        element.removeChild(element.firstChild);
                      }
                      YaPay.mountBadge(element, {
                        type: "cashback",
                        size: yps_root.plus.size || "s",
                        variant: yps_root.plus.variant || "detailed",
                        amount: paymentData.totalAmount,
                        color: yps_root.plus.color || "primary",
                        merchantId: yps_root.merchantId,
                      });
                    }
                    if (
                      gatewayKey == "yps_split" &&
                      element &&
                      yps_root.checkout_yandex_split === "yes"
                    ) {
                      // Remove all child elements from the element
                      while (element.firstChild) {
                        element.removeChild(element.firstChild);
                      }
                      YaPay.mountBadge(element, {
                        type: "bnpl",
                        size: yps_root.split.size || "s",
                        variant: yps_root.split.variant || "detailed",
                        amount: paymentData.totalAmount,
                        color: yps_root.split.color || "primary",
                        merchantId: yps_root.merchantId,
                      });
                    }

                    observer.disconnect(); // Останавливаем наблюдение
                  }
                });

                // Настраиваем observer на просмотр изменений в основном контейнере блоков
                observer.observe(document.body, {
                  childList: true,
                  subtree: true,
                });

                return true; // Return true to indicate that payment can be made
              },
              ariaLabel: label,
              supports: {
                features: settings.supports,
              },
            });
          }
        });
      })
      .catch(function (err) {
        // Не получилось создать платежную сессию.
      });
  };
  document.head.appendChild(script);
}
loadYandexPaySDK();
